<template>
    <v-tabs
        class="round-card"
        height="34"
        background-color="background-1"
        slider-color="primary">
        <v-tab ripple class="secondary-tab">
            Orari di Lavoro
        </v-tab>
        <v-tab ripple class="secondary-tab">
            Politiche SLA
        </v-tab>

        <v-tab-item class="background-1 pt-3 pb-1">
            <working-hours-config></working-hours-config>
        </v-tab-item>

        <v-tab-item class="background-1 pt-3 pb-1">
            <sla-config-list></sla-config-list>
        </v-tab-item>
    </v-tabs>
</template>

<script>
import WorkingHoursConfig from './WorkingHoursConfig.vue'
import SlaConfigList from './SlaConfigList.vue'

export default {
    name: 'SlaSettings',

    components: {
        WorkingHoursConfig,
        SlaConfigList
    },

    data() {
        return {}
    },

    mounted() {
        this.$store.commit('endProgress')
    }
}
</script>
